import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import i18n from '@/i18n';
import {
  ClientContactsListingGetters,
  ClientContactsListingMutations,
  ClientContactsListingActions
} from './client-contacts-listing.keys';
import { ClientContactListingService } from './client-contact-listing.service';

export const getInitialState = () => {
  return {
    clientContactsLoading: true,
    clientContacts: [],
    clientContactsRecordCount: 0,
    clientContactsSortOrder: {
      sortBy: 'clientContactName',
      sortDirection: 'asc'
    },
    clientContactPaginationParameters: {
      recordsPerPage: 10,
      offset: 0
    },
    clientContactActiveInactive: 'active',
    searchParam: ''
  };
};

export const ClientContactListingStore = {
  state: getInitialState(),
  getters: {
    [ClientContactsListingGetters.ClientContactsList]: state => state.clientContacts,
    [ClientContactsListingGetters.ClientContactsListSortBy]: state =>
      state.clientContactsSortOrder.sortBy,
    [ClientContactsListingGetters.ClientContactsListSortDirection]: state =>
      state.clientContactsSortOrder.sortDirection,
    [ClientContactsListingGetters.ClientContactsPerPage]: state =>
      state.clientContactPaginationParameters.recordsPerPage,
    [ClientContactsListingGetters.ClientContactsListingOffset]: state =>
      state.clientContactPaginationParameters.offset,
    [ClientContactsListingGetters.ClientContactsListingRecordCount]: state =>
      state.clientContactsRecordCount,
    [ClientContactsListingGetters.ClientContactActiveInactive]: state =>
      state.clientContactActiveInactive
  },
  mutations: {
    [ClientContactsListingMutations.SetClientContactsLoading](state, isLoading = true) {
      state.clientContactsLoading = isLoading;
    },
    [ClientContactsListingMutations.SetClientContactsList](state, clientContactsList) {
      state.clientContacts = clientContactsList;
    },
    [ClientContactsListingMutations.SetClientContactsSortOrder](state, sortOrder) {
      state.clientContactsSortOrder = sortOrder;
    },
    [ClientContactsListingMutations.SetClientContactPaginationParameters](state, pagination) {
      state.clientContactPaginationParameters = pagination;
    },
    [ClientContactsListingMutations.SetClientContactsRecordCount](state, recordCount) {
      state.clientContactsRecordCount = recordCount;
    },
    [ClientContactsListingMutations.SetClientContactsActiveInactive](state, activeInactive) {
      state.clientContactActiveInactive = activeInactive;
    },
    [ClientContactsListingMutations.SetSearchParam](state, searchParam) {
      state.searchParam = searchParam;
    },
    [ClientContactsListingMutations.ResetClientContactsPaginationOffset](state) {
      state.clientContactPaginationParameters.offset = 0;
    },
    [ClientContactsListingMutations.SetSearchParam](state, searchParam) {
      state.searchParam = searchParam;
    }
  },
  actions: {
    [ClientContactsListingActions.RetrieveContactsList]({ state, commit, dispatch }) {
      commit(ClientContactsListingMutations.SetClientContactsLoading, true);
      dispatch(ClientContactsListingActions.RetrieveContactsListCount, state.activeInactive);
      return ClientContactListingService.getContactsList(
        state.clientContactActiveInactive,
        state.clientContactsSortOrder,
        state.clientContactPaginationParameters
      )
        .then(clientContacts => {
          clientContacts.map(contacts => {
            contacts.clientContactName = contacts.last_name + ',' + contacts.first_name;
            contacts.client = contacts.name;
          });
          clientContacts.clientContactName;
          commit(ClientContactsListingMutations.SetClientContactsList, clientContacts);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('clientContacts.listing.errors.retrieveClientContacts')
          });
          commit(ClientContactsListingMutations.SetClientContactsLoading, false);
        });
    },
    [ClientContactsListingActions.UpdateClientContactsSortOrder]({ commit, dispatch }, sortOrder) {
      commit(ClientContactsListingMutations.SetClientContactsSortOrder, sortOrder);
      commit(ClientContactsListingMutations.ResetClientContactsPaginationOffset);
      dispatch(ClientContactsListingActions.RetrieveContactsList);
    },

    [ClientContactsListingActions.UpdatePaginationParams]({ commit, dispatch }, pagination) {
      commit(ClientContactsListingMutations.SetClientContactPaginationParameters, pagination);
      dispatch(ClientContactsListingActions.RetrieveContactsList);
    },
    [ClientContactsListingActions.UpdateActiveInactive]({ commit, dispatch }, activeInactive) {
      commit(ClientContactsListingMutations.SetClientContactsActiveInactive, activeInactive);
      dispatch(ClientContactsListingActions.RetrieveContactsList);
    },

    [ClientContactsListingActions.RetrieveContactsListCount]({ state, commit, dispatch }) {
      return ClientContactListingService.retrieveCount(
        state.clientContactActiveInactive,
        state.searchParam
      )
        .then(count => commit(ClientContactsListingMutations.SetClientContactsRecordCount, count))
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error
          });
        });
    },
    [ClientContactsListingActions.ExportContactsListExcel]({ state }, downloadPreference) {
      let contactsPaginationParameters = '';
      if (downloadPreference === i18n.t('clientContacts.listing.actions.exportPage')) {
        contactsPaginationParameters = state.clientContactPaginationParameters;
      }
      return ClientContactListingService.downloadExcel(
        state.clientContactActiveInactive,
        state.clientContactsSortOrder,
        contactsPaginationParameters,
        state.searchParam
      );
    },
    [ClientContactsListingActions.UpdateSearchList]: function({ commit, dispatch }, searchList) {
      commit(ClientContactsListingMutations.SetSearchParam, searchList.searchParam);
      commit(ClientContactsListingMutations.ResetClientContactsPaginationOffset);
      return dispatch(ClientContactsListingActions.RetrieveContactsListCount).then(() => {
        commit(ClientContactsListingMutations.SetClientContactsList, searchList.data);
      });
    }
  }
};
